import Api from "../api";
const basePath = "/ListTree";
export function get(id) {
    let languageId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    let includeLocation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let includeTopic = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    let includeItems = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    let includeTranslations = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    return Api.get(`${basePath}/get?id=${id}&languageId=${languageId}&includeLocation=${includeLocation}&includeTopic=${includeTopic}&includeItems=${includeItems}&includeTranslations=${includeTranslations}`);
}
export function getAll(request) {
    return Api.post(`${basePath}/getAll`, request);
}
export function getAllTreelist() {
    return Api.post(`${basePath}/getAllTreelist`, null);
}
